import { render, staticRenderFns } from "./ReportShipmentFromBranch.vue?vue&type=template&id=2a47d6f0&"
import script from "./ReportShipmentFromBranch.vue?vue&type=script&lang=js&"
export * from "./ReportShipmentFromBranch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports